import React, { useCallback } from 'react'
import { Box, ImageLoader, ResponsiveBox } from '@usap/uicomponents'
import { Text } from 'grommet'
import { formatBrand } from '@usap/carparts/src/shared/transformers/BrandText'
import PageTypeIdentifier from '@usap/carparts/src/shared/helpers/PageTypeIdentifier'
import { StarCount, Title } from '../../../../index'
import BoxItemContainer from "./SeoPopularProducts.css"

const boxCssStyle = {
  minHeight: 60,
}

const linkStyle = {
  textDecoration: 'none',
}

const brandText = {
  fontSize: '20px',
}

const boxTitleContainer = { bottom: 'small' }

const responsiveBoxFxStyle = {
  other: { horizontal: 'small' },
  large: 'medium',
}
const responsiveBoxMarginStyle = {
  bottom: 'small',
}
const textPrice = {
  fontSize: '20px',
}
const titleMargin = { horizontal: 'small' }
export default function PopularProductSection({
  Link, data, avgRating, reviewCount, isBot,
}) {
  const onClick = useCallback(() => PageTypeIdentifier.pdp(), [])

  return (
    <BoxItemContainer id="BoxContainer">
      <Box pad="small" background="white">
        <Link
          style={linkStyle}
          to={data.url}
          onClick={onClick}
        >
          <ResponsiveBox
            justify="center"
            align="center"
            fxPad={responsiveBoxFxStyle}
            margin={responsiveBoxMarginStyle}
            height="200px"
            width="200px"
          >
            <ImageLoader
              height="100%"
              width="100%"
              layout="fixed"
              fit="contain"
              alt={data.title}
              source={data.imageUrl}
              src={data.imageUrl}
              cloudinaryParams="h_200,w_200"
              isBot={isBot}
            />
          </ResponsiveBox>
        </Link>

        <Box width="100%" style={boxCssStyle}>
          <Link
            style={linkStyle}
            to={data.url}
            onClick={onClick}
          >
            <Box>
              <Text
                size="small"
                color="dark-2"
                style={brandText}
                as="strong"
              >
                {formatBrand(data.brand)}
              </Text>
            </Box>
            <Text
              size="small"
              color="dark-2"
              weight={400}
            >
              {data.title}
            </Text>
          </Link>
        </Box>

        <Box>
          <Title
            size="xsmall"
            color="dark-1"
            label={`Part No: ${data.sku}`}
          />
        </Box>
        <Box
          direction="row"
          align="start"
          margin={boxTitleContainer}
          wrap
        >
          <StarCount ratings={avgRating} />
          <Title
            size="small"
            margin={titleMargin}
            label={reviewCount > 1 ? `(${reviewCount} Reviews)` : `(${reviewCount} Review)`}
          />
        </Box>
        <Box>
          <Text
            size="small"
            color="dark-2"
            style={textPrice}
            as="strong"
          >
            $
            {data.price}
          </Text>
        </Box>
      </Box>
    </BoxItemContainer>
  )
}
